<template>
  <div class="pageContainer">
    <BannerComponent>
      <h6 class="banner-heading">Internet Speed Test</h6>
    </BannerComponent>

    <div class="card cardBackground">
      <!--OST Widget code start-->
      <div style="text-align:right;width: 100%;">
        <!-- iOS Native Browser Option -->
<!--        <div v-if="isIOS" style="min-height:360px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
          <div style="padding: 40px;">
            <h5 style="margin-bottom: 20px; color: #333;">Internet Speed Test</h5>
            <p style="margin-bottom: 30px; color: #666; line-height: 1.5;">
              For the best testing experience on iOS, tap the button below to open the speed test in your browser.
            </p>
            <button 
              @click="openSpeedTestInBrowser" 
              style="background-color: #007AFF; color: white; border: none; border-radius: 8px; padding: 15px 30px; font-size: 16px; font-weight: 600; cursor: pointer;"
              :style="{ opacity: loading ? 0.7 : 1 }"
              :disabled="loading"
            >
              {{ loading ? 'Opening...' : 'Open Speed Test' }}
            </button>
          </div>
        </div>-->
        <!-- Web/Android Iframe -->
        <div style="min-height:360px;">
          <div style="width:100%;height:0;padding-bottom:50%;position:relative;background-color: transparent">
            <iframe 
              style="border:none;position:absolute;top:0;left:0;width:100%;height:100%;min-height:360px;border:none;overflow:hidden !important;" 
              src="https://openspeedtest.com/speedtest"
              allow="accelerometer; autoplay; camera; clipboard-write; encrypted-media; geolocation; gyroscope; microphone; picture-in-picture; web-share"
              sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
              loading="lazy">
            </iframe>
          </div>
        </div>
        Provided by <a href="https://openspeedtest.com">OpenSpeedtest.com</a>
      </div>
      <!-- OST Widget code end -->
    </div>

    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import BannerComponent from "@/components/BannerComponent.vue";
import MessageModal from "@/components/MessageModal.vue";
import LoadingPage from "@/components/LoadingPage.vue";
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export default {
  name: 'SpeedTestPage',
  components: {
    BannerComponent,
    MessageModal,
    LoadingPage,
  },
  data() {
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
      loading: false,
      isIOS: false,
    };
  },
  mounted() {
    this.isIOS = Capacitor.getPlatform() === 'ios';
  },
  methods: {
    async openSpeedTestInBrowser() {
      try {
        await Browser.open({
          url: 'https://openspeedtest.com/speedtest',
          presentationStyle: 'fullscreen'
        });
      } catch (error) {
        console.error('Error opening browser:', error);
        this.appMessage = {
          text: 'Unable to open speed test. Please try again.',
          type: 'error'
        };
        this.$refs.messageModal.showModal();
      }
    }
  },
};
</script>

<style scoped>

</style>